
import * as React from 'react';
import { ColorType, colorMapping } from '../../common';
import { Button as ButtonStrap } from 'reactstrap';

export interface IButtonProps extends React.HTMLProps<HTMLButtonElement> {
    colorType?: ColorType;
    onClick?: React.MouseEventHandler<any>;
    size?: ButtonSize;
    outline?: boolean;
    active?: boolean;
    block?: boolean;
    disabled?: boolean;
    working?: boolean;
    allowPropagation?: boolean;
    tag?: React.ReactType;
}

export enum ButtonSize {
    Default,
    Large,
    Small
}

const sizeMapping: any = {
    [ButtonSize.Default]: undefined,
    [ButtonSize.Small]: 'sm',
    [ButtonSize.Large]: 'lg',
}

export const Button: React.FC<IButtonProps> = (props: IButtonProps) => {
    const { colorType, ref, ...others } = props;
    return <ButtonStrap {...others} onClick={(e: any) => { if (!props.allowPropagation) { e.stopPropagation(); } props.onClick && props.onClick(e) }}
        color={colorMapping[props.colorType || ColorType.Default]}
        size={sizeMapping[props.size || ButtonSize.Default]}
    >
        {props.working ? <i className="fa fa-sync fa-spin" aria-hidden="true"></i> : null}
        {props.children}
    </ButtonStrap>;
};

export const ButtonPrimary = (props: IButtonProps) => {
    return <Button {...props} colorType={ColorType.Primary} />;
}

export const ButtonSecondary = (props: IButtonProps) => {
    return <Button {...props} colorType={ColorType.Secondary} />;
}

export const ButtonDefault = (props: IButtonProps) => {
    return <Button {...props} colorType={ColorType.Default} />;
}

export const ButtonLink = (props: IButtonProps) => {
    return <Button {...props} colorType={ColorType.Link} />;
}
